import { combineReducers } from 'redux';
import {
    RECEIVE_CONTACT_REQUEST_REASON,
    REQUEST_CONTACT_REQUEST_REASON,
    FAILURE_CONTACT_REQUEST_REASON,
    REQUEST_FORM_SUBMIT_CONTACT_REQUEST,
    SUCCESS_FORM_SUBMIT_CONTACT_REQUEST,
    FAILURE_FORM_SUBMIT_CONTACT_REQUEST,
    RESET_FORM_SUBMIT_CONTACT_REQUEST
} from './constants';

const contactrequestreasons = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_CONTACT_REQUEST_REASON:
            return [...state, ...action.response.payload];
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_CONTACT_REQUEST_REASON:
        case REQUEST_FORM_SUBMIT_CONTACT_REQUEST:
            return true;
        case RECEIVE_CONTACT_REQUEST_REASON:
        case SUCCESS_FORM_SUBMIT_CONTACT_REQUEST:
        case FAILURE_CONTACT_REQUEST_REASON:
        case FAILURE_FORM_SUBMIT_CONTACT_REQUEST:
        case RESET_FORM_SUBMIT_CONTACT_REQUEST:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_CONTACT_REQUEST_REASON:
        case FAILURE_FORM_SUBMIT_CONTACT_REQUEST:
            return action.response.message;
        case RECEIVE_CONTACT_REQUEST_REASON:
        case SUCCESS_FORM_SUBMIT_CONTACT_REQUEST:
        case REQUEST_CONTACT_REQUEST_REASON:
        case REQUEST_FORM_SUBMIT_CONTACT_REQUEST:
        case RESET_FORM_SUBMIT_CONTACT_REQUEST:
            return '';
        default:
            return state;
    }
};

const successContactRequestSubmit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_FORM_SUBMIT_CONTACT_REQUEST:
            return true;
        case REQUEST_FORM_SUBMIT_CONTACT_REQUEST:
        case FAILURE_FORM_SUBMIT_CONTACT_REQUEST:
        case RESET_FORM_SUBMIT_CONTACT_REQUEST:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    contactrequestreasons,
    successContactRequestSubmit,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/contactrequest/reducer.js